import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import LoginPage from "@/LoginPage";
import AuthCallback from "@/AuthCallback";
import { AuthProvider, useAuth } from "@/auth";

function Shell() {
  const { user, loading } = useAuth();

  // Callback OAuth: procesar session_id antes de cualquier otra cosa
  if (window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <p className="text-slate-400 text-sm">Cargando…</p>
      </div>
    );
  }

  if (!user) return <LoginPage />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Shell />
    </AuthProvider>
  </React.StrictMode>,
);
